import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

import { useUnleash } from '@/hooks/unleash';
import { PaleState } from '@/interfaces';
import { actions as appStateActions } from '../../state/appStateActions';
import ResultCount from '../resultList/ResultCount';
import SortDropdown from '../filters/SortDropdown';

interface Props {
    filtersOpen: boolean;
    openFilter: (filtersOpen: boolean) => void;
}

export const MobileTopBar: React.FC<Props> = ({ filtersOpen, openFilter }): ReactElement<Props> => {
    const unleash = useUnleash();

    const onClick = (): void => {
        openFilter(!filtersOpen);
    };

    return (
        <>
            <div className="grid u-pa16 topbar-level2" data-testid="mobileTopBar">
                <div className="grid__unit u-size1of2 u-mt4" data-testid="count">
                    <ResultCount />
                </div>
                <div className="grid__unit u-size1of2" data-testid="showFilter">
                    <button
                        className={`button button--small u-float-right ${filtersOpen ? 'button--cta' : 'button--default'}`}
                        onClick={onClick}
                        data-testid="showFilterButton">
                        {filtersOpen ? 'Vis resultat' : 'Vis filter'}
                    </button>
                </div>
            </div>
            {!unleash.destinationAutocomplete && <hr />}
            <div className={unleash.destinationAutocomplete ? '' : 'u-pv16'}>
                <SortDropdown selectId="sortDropdownMobile" />
            </div>
        </>
    );
};

const mapStateToProps = (state: PaleState): Pick<Props, 'filtersOpen'> => ({
    filtersOpen: state.appState.filtersOpen,
});

export default connect(mapStateToProps, { openFilter: appStateActions.openFilter })(MobileTopBar);
